/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, getArrTypeAttr, getBooleanTypeAttr, getStrTypeAttr, removeAttrs, setHtml } from '../../dom-utils';
import { warn } from '../../mixins';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var Checkbox = /** @class */ (function () {
    function Checkbox() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-checkbox', { all: true });
        this._create(this.COMPONENTS);
    }
    Checkbox.prototype.config = function (el) {
        var target = $el(el);
        var isGroup = target.tagName.toLowerCase() == 'r-checkbox-group';
        // 排除 group 项
        if (!isGroup) {
            validComps(target, 'checkbox');
        }
        else {
            validComps(target, 'checkbox-group');
        }
        var _a = Checkbox.prototype, _attrs = _a._attrs, _setChecked = _a._setChecked, _setIndeterminate = _a._setIndeterminate, _setMultipleChecks = _a._setMultipleChecks, _isDisabled = _a._isDisabled;
        var value = _attrs(target).value;
        return {
            get value() {
                return value;
            },
            set value(newVal) {
                if (!isGroup) {
                    warn("This checkbox is not a child of a group element -->\"" + el + "\"");
                    return;
                }
                if (newVal && !type.isArr(newVal))
                    return;
                _setMultipleChecks(target, newVal);
            },
            get checked() {
                return target.dataset['value'] === 'true';
            },
            set checked(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                _setChecked(target, newVal);
            },
            get disabled() {
                return _isDisabled(target);
            },
            set disabled(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                if (isGroup)
                    return;
                newVal
                    ? target.setAttribute('disabled', 'disabled')
                    : target.removeAttribute('disabled');
                var CheckBoxInput = target.querySelector("." + PREFIX.checkbox + "-input");
                CheckBoxInput.disabled = newVal;
            },
            get indeterminate() {
                var isIndeterminate = target
                    .querySelector("." + PREFIX.checkbox)
                    .classList.contains(PREFIX.checkbox + "-indeterminate");
                return isIndeterminate;
            },
            set indeterminate(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                if (isGroup)
                    return;
                _setIndeterminate(target, newVal);
            },
            events: function (_a) {
                var onChange = _a.onChange;
                var CheckBox, checked;
                isGroup ? (CheckBox = target.querySelectorAll('r-checkbox')) : (CheckBox = target);
                var fn = function () {
                    if (isGroup) {
                        checked = [];
                        CheckBox.forEach(function (elm) {
                            elm.dataset['value'] === 'true'
                                ? checked.push(elm.dataset['label'])
                                : '';
                        });
                    }
                    else {
                        checked = target.dataset['value'] === 'true';
                    }
                    onChange && type.isFn(onChange, checked);
                };
                bind(target, 'click', fn);
            }
        };
    };
    Checkbox.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), icon = _a.icon, name = _a.name, checked = _a.checked, label = _a.label, indeterminate = _a.indeterminate;
            var CheckboxGroupWrapper = _this._getGroupWrapper(node);
            _this._setChecked(node, checked);
            _this._setMainTemplate(node, name);
            _this._setLabel(node, label);
            _this._setDisabled(node);
            _this._setIcon(node, icon);
            _this._setIndeterminate(node, indeterminate);
            _this._handleChange(node);
            if (CheckboxGroupWrapper) {
                var value = _this._attrs(CheckboxGroupWrapper).value;
                _this._setMultipleChecks(CheckboxGroupWrapper, value);
                removeAttrs(CheckboxGroupWrapper, ['value']);
            }
            removeAttrs(node, ['icon', 'name', 'checked', 'label']);
        });
    };
    Checkbox.prototype._setChecked = function (node, checked) {
        // @ts-ignore
        node.dataset['value'] = "" + checked;
        if (!checked) {
            if (node.classList.contains(PREFIX.checkbox + "-checked")) {
                node.classList.remove(PREFIX.checkbox + "-checked");
            }
        }
        else {
            node.classList.add(PREFIX.checkbox + "-checked");
        }
    };
    Checkbox.prototype._setMainTemplate = function (node, name) {
        var content = setHtml(node);
        var template = "\n         <span class=\"" + PREFIX.checkbox + "\">\n            <span class=\"" + PREFIX.checkbox + "-inner\"></span>\n                <input type=\"checkbox\" class=\"" + PREFIX.checkbox + "-input\" name=\"" + name + "\">\n            </span>\n         <span>" + content + "</span>\n        ";
        setHtml(node, template);
    };
    Checkbox.prototype._setLabel = function (node, label) {
        if (!this._getGroupWrapper(node))
            return;
        // @ts-ignore
        node.dataset['label'] = label;
    };
    Checkbox.prototype._setDisabled = function (node) {
        if (!this._isDisabled(node))
            return;
        var CheckBoxInput = node.querySelector("." + PREFIX.checkbox + "-input");
        CheckBoxInput.disabled = true;
    };
    Checkbox.prototype._setIcon = function (node, icon) {
        if (!icon)
            return;
        var template = "<i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-" + icon + "\"></i>";
        node.querySelector("." + PREFIX.checkbox).insertAdjacentHTML('afterend', template);
    };
    Checkbox.prototype._setIndeterminate = function (node, indeterminate) {
        var Checkbox = node.querySelector("." + PREFIX.checkbox);
        if (!indeterminate) {
            if (Checkbox.classList.contains(PREFIX.checkbox + "-indeterminate")) {
                Checkbox.classList.remove(PREFIX.checkbox + "-indeterminate");
            }
        }
        else {
            Checkbox.classList.add(PREFIX.checkbox + "-indeterminate");
        }
    };
    Checkbox.prototype._setMultipleChecks = function (checkboxGroupWrapper, value) {
        var _setChecked = Checkbox.prototype._setChecked;
        var Checkboxs = checkboxGroupWrapper.querySelectorAll('r-checkbox');
        var length = value.length;
        if (length == 0) {
            Checkboxs.forEach(function (elm) { return _setChecked(elm, false); });
        }
        else {
            var i = 0;
            for (; i < length; i++) {
                var currentCheckbox = checkboxGroupWrapper.querySelector("[data-label=\"" + value[i] + "\"]");
                currentCheckbox ? _setChecked(currentCheckbox, true) : '';
            }
        }
    };
    Checkbox.prototype._handleChange = function (node) {
        var _this = this;
        var addFocusedState = function () {
            var CheckBoxInner = node.querySelector("." + PREFIX.checkbox + "-inner");
            CheckBoxInner.classList.add(PREFIX.checkbox + "-focus");
            setTimeout(function () { return CheckBoxInner.classList.remove(PREFIX.checkbox + "-focus"); }, 1500);
        };
        var toogle = function () {
            // @ts-ignore
            var isChecked = node.dataset['value'] === 'true' ? false : true;
            var isDisabled = _this._isDisabled(node);
            if (isDisabled)
                return false;
            addFocusedState();
            _this._setChecked(node, isChecked);
        };
        bind(node, 'click', toogle);
    };
    Checkbox.prototype._isDisabled = function (node) {
        return node.getAttribute('disabled') == '' || node.getAttribute('disabled') == 'true';
    };
    Checkbox.prototype._getGroupWrapper = function (node) {
        var parent = node.parentElement;
        return (parent === null || parent === void 0 ? void 0 : parent.tagName.toLowerCase()) === 'r-checkbox-group' ? parent : null;
    };
    Checkbox.prototype._attrs = function (node) {
        return {
            icon: getStrTypeAttr(node, 'icon', ''),
            name: getStrTypeAttr(node, 'name', ''),
            label: getStrTypeAttr(node, 'label', ''),
            value: getArrTypeAttr(node, 'value'),
            checked: getBooleanTypeAttr(node, 'checked'),
            indeterminate: getBooleanTypeAttr(node, 'indeterminate')
        };
    };
    return Checkbox;
}());
export default Checkbox;
